import { GeolocationDeniedTranslation } from '../../types/geolocationDenied.types';

export const geolocationDenied: GeolocationDeniedTranslation = {
  title: 'Geolocalización bloqueada',
  firstParagraph:
    '¡Ups! Parece que bloqueaste el acceso a tu ubicación. Para continuar, necesitas permitir que sepamos dónde te encuentras.',
  secondParagraph: {
    part1: 'Para habilitar tu ubicación, ve a la',
    siteSettings: 'Configuración del sitio',
    part2: ', haciendo clic en el ícono de candado antes de la dirección de la plataforma. En la sección',
    permissions: 'Permisos',
    part3: ', deja la opción de',
    location: 'Ubicación',
    part4: 'en',
    allow: 'Permitir',
  },
  retry: 'Intentar nuevamente',
};

export default geolocationDenied;
